import { InviteLinkShareStepType, StepInfo } from '@/types/steps.type';

import { InviteLinkShareStep } from './InviteLinkShareStep';

export const InviteLinkShareStepInfo: StepInfo<InviteLinkShareStepType> = {
  Component: InviteLinkShareStep,
  id: 'inviteLinkShareStep',
  stepName: 'Share Invite Link Screen',
  /** Title/desc render inside the step (illustration first); empty skips `Step` header */
  title: '',
  desc: undefined,
};

export { InviteLinkShareStep } from './InviteLinkShareStep';
